<template>
  <div class="c-moniadd g-container">
    <moduler name="moniadd" :title="title">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">选择管控账号</span>
        </Col>
        <Col span="12">
          <adcount-selecter v-model="monitor.accountIds" :filter-acounts="[10, 16]" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">规则类型</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="monitor.ruleType" type="button">
            <Radio :label="1">暂停计划</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">预警消耗值</span>
        </Col>
        <Col span="12">
          <adcount-condtion v-if="monitor.warnAmounts.length" v-model="monitor.warnAmounts" :max-len="5" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">干预消耗值</span>
        </Col>
        <Col span="12">
          <input-number-plus
            :max="10"
            :min="0.1"
            :step="0.1"
            :precision="2"
            v-model="monitor.interveneAmount"
            placeholder="请输入总消耗值，范围：0-999999999.99 保留两位小数"
            :width="352"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">管控数据时间范围</span>
        </Col>
        <Col span="12">
          <DateRangePicker v-model="monitor.dataRange" style="width: 352px" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">监测频率</span>
        </Col>
        <Col span="3" style="width: 100px">
          <RadioGroup v-model="monitor.monitorTimes" vertical>
            <Radio :label="1">每5分钟</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">提醒类型</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="monitor.alertType" type="button">
            <Radio :label="1">仅钉钉</Radio>
            <Radio :label="2">仅邮件</Radio>
            <Radio :label="3">钉钉+邮件</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">提醒人员</span>
        </Col>
        <Col span="12">
          <el-select v-model="monitor.alertOpIds" :popper-append-to-body="false" multiple filterable style="width: 352px">
            <el-option v-for="p in operatorData" :key="p.id" :value="p.id" :label="p.name"></el-option>
          </el-select>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">规则名称</span>
        </Col>
        <Col span="12">
          <input-len v-model="monitor.ruleName" placeholder="最大60个字符，1个中文等于2个字符" :max="60" width="352" />
        </Col>
      </Row>
    </moduler>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="save">
            <span v-if="!loading">保存规则</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">新增规则</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import validMixin from '../mixins/valid-mixin'
import filterWarns from '../data/filters_warn'
import { mul, div } from '@/common/js/api'
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { editAdcount, getAdcount } from '@/api/tools.model'
import { getSysMember } from '@/api/common.model'
import AdcountCondtion from './components/adcount-condtion.vue'
import AdcountSelecter from './components/adcount-selecter.vue'
import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import DateRangePicker from '@/components/date-range-picker'

export default {
  name: 'monitordata',
  mixins: [validMixin],
  components: { Moduler, ErrorPop, InputLen, AdcountCondtion, AdcountSelecter, InputNumberPlus, DateRangePicker },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    title() {
      const str = this.editState ? '修改' : '新增'
      return `${str}管控规则`
    }
  },
  methods: {
    getData() {
      // 加载动画
      this.$Spin.show()
      const ruleId = Number(this.monitor.ruleId)
      if (isEmpty(ruleId)) return
      getAdcount({ ruleId })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            const {
              accountIds,
              ruleName,
              ruleType,
              alertType,
              interveneAmount,
              monitorStartTime,
              monitorEndTime,
              alertOpIds,
              monitorTimes,
              warnAmounts
            } = data
            // 返回值详情
            this.monitor = Object.assign(this.monitor, {
              accountIds: accountIds.map((ret) => Number(ret)),
              ruleName,
              ruleType,
              alertType,
              interveneAmount,
              dataRange: [monitorStartTime, monitorEndTime],
              alertOpIds: alertOpIds.map((ret) => Number(ret)),
              monitorTimes,
              warnAmounts
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    proloadData() {
      this.$Spin.show()
      Promise.all([getSysMember()]).then((data) => {
        this.$Spin.hide()
        const [operatorData] = data
        if (isArray(operatorData)) this.operatorData = operatorData
      })
    },

    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = String(val)
    },
    customValid() {
      const err = []
      // 预警消耗值
      const condiValid = this.monitor.warnAmounts.some((ret) => isEmpty(ret) || Number(ret) < 0.1 || Number(ret) > 999999999.99)
      if (condiValid) {
        err.push({ feild: '预警消耗值', msg: '消耗值验证不通过，范围：0-999999999.99，最多2位小数' })
      }
      // 干预消耗值
      if (this.monitor.interveneAmount < 0.1 || this.monitor.interveneAmount > 999999999.99) {
        err.push({ feild: '干预消耗值', msg: '范围：0-999999999.99，最多2位小数' })
      }
      // 时间范围
      if (isArray(this.monitor.dataRange) && this.monitor.dataRange.length) {
        const [start, end] = this.monitor.dataRange
        if (isEmpty(start) || isEmpty(end)) err.push({ feild: '管控数据时间范围', msg: '时间范围不能为空' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'monitor/ruleName',
          require: true,
          min: 2,
          max: 60,
          desc: '规则名称'
        },
        {
          name: 'monitor/accountIds',
          require: true,
          min: 1,
          desc: '管控账号'
        },
        {
          name: 'monitor/dataRange',
          require: true,
          min: 1,
          desc: '管控数据时间范围'
        },
        {
          name: 'monitor/alertOpIds',
          require: true,
          min: 1,
          desc: '提醒人员'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      // 复制取消提交的id
      const { ruleId, dataRange, warnAmounts, ...rest } = this.monitor

      const [startTime, endTime] = dataRange
      const params = Object.assign({}, rest, {
        monitorStartTime: startTime,
        monitorEndTime: endTime,
        warnAmounts: warnAmounts.sort((a, b) => a - b)
      })

      this.$Spin.show()
      this.loading = true
      editAdcount(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const [startTime, endTime] = this.monitor.dataRange
      const params = Object.assign({}, this.monitor, {
        monitorStartTime: startTime,
        monitorEndTime: endTime,
        warnAmounts: this.monitor.warnAmounts.sort((a, b) => a - b)
      })
      this.$Spin.show()
      this.loading = true
      editAdcount(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '编辑成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    jump() {
      this.$router.push({ name: 'adcountwarnrules' })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    }
  },
  data() {
    return {
      ruleData: filterWarns,
      monitor: {
        ruleId: this.$route.query.id, // 修改id
        ruleName: '',
        ruleType: 1,
        accountIds: [], // 管控账号
        warnAmounts: [], // 预警5档
        interveneAmount: '', // 干预
        alertOpIds: [], // 提醒人员
        alertType: 1, // 提醒规则
        monitorTimes: 1, // 提醒时间
        dataRange: [] // 数据统计周期
      },
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      operatorData: [] // 系统人员
    }
  },
  created() {
    this.proloadData()
    if (this.monitor.ruleId) this.getData()
  },
  mounted() {
    if (!this.monitor.ruleId) this.monitor.warnAmounts.push('')
  }
}
</script>
<style lang="scss" scoped>
.c-moniadd {
  overflow: auto;
  height: calc(100vh - 160px);

  .c-rule-info {
    height: 32px;
    min-width: 168px;
    margin-bottom: 12px;
    display: flex;

    .info-label {
      line-height: 32px;
      width: 36px;
      flex: 0 0 36px;
    }

    .info-content {
      flex: 0 0 auto;
    }
  }

  .item-btn-span {
    margin-right: 12px;
  }

  .m-switch {
    padding: 5px 0;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;
    margin-bottom: 20px;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  /* 表单选项 */
  .row-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 32px;

    .col-item {
      text-align: right;
    }

    i {
      margin-right: 4px;
      vertical-align: middle;

      &.ivu-icon-md-add {
        margin: 0;
      }
    }

    .item-field {
      font-size: 14px;
      padding-right: 12px;
      height: 32px;
      line-height: 32px;
    }

    /* 必填项 */
    .row-item-must {
      position: relative;
      z-index: 5;

      &:after {
        content: ' ';
        display: inline-block;
        width: 4px;
        height: 4px;
        position: absolute;
        top: 6px;
        right: 0;
        background-color: #f45858;
        border-radius: 3px;
      }
    }
  }

  .m-radio-select {
    height: 90px;
    display: flex;
    align-items: flex-end;

    .ivu-select {
      width: 180px;
    }
  }
}
</style>
